/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-20 14:14:08
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-20 14:14:22
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/Query1/Filter/tools.ts
 */
const getLabel = (keys, options) => {
  return keys.map((key) => {
    const t = options.find((i) => i.value === key);
    const { label } = t || {};
    return { label, value: key };
  });
};
export { getLabel };
